module.exports = __webpack_public_path__ + "img/feide.4001f53d.webp";